// modules
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
// component
import { MessageSeenListDrawer } from './message-seen-list'

const COMPONENT_ID = 'messageSeenList'

const showMessageSeenList = (
  props: Parameters<typeof MessageSeenListDrawer>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showMessageSeenListDrawer = (
  viewers: { userId: string; seenAt: Date }[],
) =>
  showMessageSeenList({
    viewers,
    onClose: closeCurrentModal,
  })

export default {
  [COMPONENT_ID]: {
    Component: MessageSeenListDrawer,
  },
}
